import {Button} from "@dp-instant/ui";
import {Action, lazyGet} from "@dp-instant/core";
import {TypesNotification} from "@dp-instant/interfaces";

export const DebugPanelNotifications = () => (
    <div>
        <span>Notifications</span>
        <Button onClick={() => lazyGet<Action>(TypesNotification.start)?.run()}>
            Send notification
        </Button>
    </div>
);
